// extracted by mini-css-extract-plugin
export default {"root":"IconSchedule_root__OnNQR"};